import TitleBar from '../../../components/TitleBar';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components';
import { useUserContext } from '../../../context/PermissionsContext';
import TitleUpdater from '../../../components/common/TitleUpdater';
import useCyberFlag from '../../../hooks/cyber/useCyberFlag';
import { FloatingVideoHelpButton } from '../../../components/FloatingVideoHelpButton';

function DataInputs() {
  const navigate = useNavigate();

  const { isLocation } = useUserContext();
  const { isEnabled } = useCyberFlag();

  // Check if backend URL contains "local" or "dev" to conditionally show the help button
  const shouldShowHelpButton = process.env.REACT_APP_BACKEND_URL?.includes('local') || 
                              process.env.REACT_APP_BACKEND_URL?.includes('dev');

  const DATA_INPUTS_OPTIONS = [
    {
      section: 'Financials',
      slug: '/financials-corporate',
      shouldShowIt: !isLocation,
    },
    {
      section: 'Locations & Process Areas',
      slug: '/locations',
      shouldShowIt: true,
    },
    {
      section: 'Suppliers',
      slug: '/suppliers',
      shouldShowIt: true,
    },
    {
      section: 'External Mitigating Locations',
      slug: '/mitigating-locations',
      shouldShowIt: true,
    },
    {
      section: 'IT Applications',
      slug: '/data-inputs/it-applications',
      shouldShowIt: true,
    },
    {
      section: 'Hosting Entities & Sub-Entities',
      slug: '/data-inputs/hosting-entities-sub-entities',
      shouldShowIt: isEnabled,
    },
    {
      section: 'Business Functions',
      slug: '/data-inputs/business-functions',
      shouldShowIt: true,
    },
    {
      section: 'Qualitative Factors',
      slug: '/data-inputs/qualitative-factors',
      shouldShowIt: isEnabled,
    },
  ];

  return (
    <div>
      <TitleUpdater title="Data Inputs" />
      <TitleBar
        title="Data Inputs"
        subtitle="Overview"
        brief="Adding the data below forms the basis for the risk quantification and business continuity
                      planning process. The more detail added here, the better. If all the information is not available
                      right now, it can also be added later."
      />
      <div className="flex flex-nowrap flex-col items-center justify-center max-w-176 mx-auto">
        {DATA_INPUTS_OPTIONS?.map(
          ({ section, slug, shouldShowIt }) =>
            shouldShowIt && (
              <Button
                key={section}
                type="primary"
                className="w-full my-2 py-4 text-base"
                onClick={() => navigate(slug)}
              >
                {section}
              </Button>
            ),
        )}
      </div>
      {shouldShowHelpButton && (
        <FloatingVideoHelpButton
          position="bottom-right"
          filename="Data Inputs Overview.mp4"
          title="Data Inputs Overview"
        />
      )}
    </div>
  );
}

export default DataInputs;
